"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.functionStatement = ({ ast, execObject }) => {
    const functionName = ast.children.FunctionNameToken[0].image.slice(0, -1);
    const argAst = ast.children.arguments[0];
    const funcArguments = argAst.children.Identifier !== undefined
        ? argAst.children.Identifier.map((x) => {
            return x.image;
        })
        : [];
    execObject.manager.function.assignment(functionName, funcArguments, ast.children.rules[0]);
    return;
};
